import { Controller } from "@hotwired/stimulus"
import { Modal, Popover, Tooltip } from "bootstrap"

export default class BootStrapController extends Controller {

  connect() {
    this.initializeBootstrap()
    this.initializeSidebar()
  }

  initializeBootstrap() {
    // Initialize tooltips
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
      new Tooltip(el);
    })

    // Initialize popovers
    document.querySelectorAll('[data-bs-toggle="popover"]').forEach(el => {
      new Popover(el);
    })

    // Initialize modals
    document.querySelectorAll('[data-toggle="modal"]').forEach(el => {
      el.addEventListener('click', evt => {
        evt.preventDefault();
        let target = document.getElementById(evt.target.dataset.target);
        let modal = new Modal(target);
        modal.show();
      })
    })
  }

  initializeSidebar() {
    this.initializeSimplebar()
    this.initializeSidebarCollapse()
  }

  initializeSimplebar() {
    const simplebarElement = document.getElementsByClassName("js-simplebar")[0];

    if(simplebarElement && window.SimpleBar){
      const simplebarInstance = new window.SimpleBar(simplebarElement);

      /* Recalculate simplebar on sidebar dropdown toggle */
      const sidebarDropdowns = document.querySelectorAll(".js-sidebar [data-bs-parent]");

      sidebarDropdowns.forEach(link => {
        link.addEventListener("shown.bs.collapse", () => {
          simplebarInstance.recalculate();
        });
        link.addEventListener("hidden.bs.collapse", () => {
          simplebarInstance.recalculate();
        });
      });
    }
  }

  initializeSidebarCollapse() {
    const sidebarElement = document.getElementsByClassName("js-sidebar")[0];
    const sidebarToggleElement = document.getElementsByClassName("js-sidebar-toggle")[0];

    if(sidebarElement && sidebarToggleElement) {
      sidebarToggleElement.addEventListener("click", () => {
        sidebarElement.classList.toggle("collapsed");

        sidebarElement.addEventListener("transitionend", () => {
          window.dispatchEvent(new Event("resize"));
        });
      });
    }
  }

  // Legacy method for backward compatibility
  attach(event) {
    this.initializeBootstrap()
    this.initializeSidebar()
  }
}